<template>
  <div id="app">
    <ConfigProvider :locale="locale">
      <v-app>
        <ApplicationLayout>
          <ApplicationSidebar slot="sidebar" />
          <ApplicationHeader slot="header" />
          <ApplicationToolbar slot="toolbar" />
          <router-view slot="content" />
          <ApplicationFooter slot="footer" />
        </ApplicationLayout>
      </v-app>
    </ConfigProvider>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { ConfigProvider } from 'ant-design-vue';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import frFR from 'ant-design-vue/lib/locale-provider/fr_FR';
import { mapGetters } from 'vuex';
import ApplicationHeader from '@/components/core/ApplicationHeader/ApplicationHeader.vue';
import ApplicationSidebar from '@/components/core/ApplicationSidebar/ApplicationSidebar.vue';
import ApplicationLayout from '@/components/core/ApplicationLayout/ApplicationLayout.vue';
import ApplicationToolbar from '@/components/core/ApplicationToolbar/ApplicationToolbar.vue';
import ApplicationFooter from '@/components/core/ApplicationFooter/ApplicationFooter.vue';
import '@/assets/styles/global.scss';

export default Vue.extend({
  name: 'App',
  components: {
    ApplicationHeader,
    ApplicationLayout,
    ApplicationSidebar,
    ApplicationToolbar,
    ApplicationFooter,
    ConfigProvider
  },
  data: () => ({}),
  computed: {
    locale() {
      this.setLocale(this.userLocale);

      if (this.userLocale.startsWith('fr')) {
        return frFR;
      }
      return enUS;
    },
    ...mapGetters({
      userLocale: 'user/getCurrentUserLocale'
    })
  },
  watch: {
    userLocale: 'setLocale'
  },
  methods: {
    setLocale(locale: string) {
      this.$i18n.locale = locale;
    }
  }

});
</script>
